import { useState } from 'react';
import { Clipboard, SafeAreaView, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { COLORS } from '../../styles/colors';
import { fontFamilies } from '../../utils/fontLoader';

// This component is now ONLY the black content panel. The close button is handled by the parent.
const CustomShareModal = ({ shareUrl, onNativeShare }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyLink = () => {
    if (shareUrl) {
      Clipboard.setString(shareUrl);
      setIsCopied(true);
      // Reset after 2 seconds
      setTimeout(() => setIsCopied(false), 2000);
    }
  };

  return (
    <View style={styles.overlayContainer}>
      <SafeAreaView style={styles.safeArea}>
        {/* Main Content Section */}
        <View style={styles.contentContainer}>
          <Text style={styles.title}>Use the link below to share</Text>
          <Text style={styles.description}>
            Get a second opinion from someone you trust. Share this match and see what they think.
          </Text>

          <View style={styles.linkContainer}>
            <Text style={styles.linkText} numberOfLines={1} ellipsizeMode="tail">
              {shareUrl}
            </Text>
          </View>

          <View style={styles.buttonsRow}>
            <TouchableOpacity
              style={styles.primaryButton}
              onPress={handleCopyLink}
              disabled={isCopied}
            >
              <Text style={styles.primaryButtonText}>{isCopied ? 'Copied' : 'Copy link'}</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.secondaryButton} onPress={onNativeShare}>
              <Text style={styles.secondaryButtonText}>Share to App...</Text>
            </TouchableOpacity>
          </View>
        </View>
      </SafeAreaView>
    </View>
  );
};

const styles = StyleSheet.create({
  overlayContainer: {
    flex: 1,
    backgroundColor: '#0E0E0E',
  },
  safeArea: {
    flex: 1,
    // Prevents content from going under notches, but the overlay itself fills the screen
  },
  contentContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 32,
    paddingBottom: 80,
  },
  title: {
    color: COLORS.white,
    fontFamily: fontFamilies.satoshi.regular,
    fontSize: 44,
    lineHeight: 53,
    letterSpacing: -0.44,
    textAlign: 'center',
    marginBottom: 32,
    maxWidth: 400,
  },
  description: {
    color: 'rgba(255, 255, 255, 0.8)',
    fontFamily: fontFamilies.satoshi.regular,
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 40,
    maxWidth: 500,
    lineHeight: 29,
  },
  linkContainer: {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: 99,
    paddingVertical: 16,
    paddingHorizontal: 24,
    width: '100%',
    maxWidth: 500,
    marginBottom: 24,
    borderWidth: 1,
    borderColor: 'rgba(130, 134, 140, 0.2)',
  },
  linkText: {
    color: '#FFFFFF',
    fontFamily: fontFamilies.satoshi.medium,
    fontSize: 17,
    lineHeight: 27,
  },
  buttonsRow: {
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 16,
    width: '100%',
    maxWidth: 500,
  },
  primaryButton: {
    backgroundColor: COLORS.white,
    borderRadius: 32,
    paddingVertical: 12,
    paddingHorizontal: 48,
    alignItems: 'center',
    width: '100%',
  },
  primaryButtonText: {
    color: '#000000',
    fontFamily: fontFamilies.satoshi.bold,
    fontSize: 14,
    letterSpacing: -0.14,
  },
  secondaryButton: {
    backgroundColor: '#252525',
    borderRadius: 32,
    paddingVertical: 12,
    paddingHorizontal: 48,
    alignItems: 'center',
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.2)',
    width: '100%',
  },
  secondaryButtonText: {
    color: COLORS.white,
    fontFamily: fontFamilies.satoshi.bold,
    fontSize: 14,
    letterSpacing: -0.14,
  },
});

export default CustomShareModal;
